import { DividerProps } from '@ui-system/interfaces-divider';

const defaultProps: Partial<DividerProps> = {
  color: 'gray.A100',
};
export default defaultProps;
